import { BILLING_ADDRESS, OTHER_DETAILS } from '../MyLicence/expressLetter';

export const AIRCRAFT_STATION_INFORMATION = 'aircraft-station-info';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const HF_TRANSCEIVER = 'hf-transceiver';
export const VHF_TRANSCEIVER = 'vhf-transceiver';
export const ADF_TRANSCEIVER = 'adf-transceiver';
export const EMERGENCY_RADIO_BEACON = 'emergency-radio-beacon';
export const MARKER_RECEIVER = 'marker-receiver';
export const VHF_NAV_TRANSCEIVER = 'vhf-nav-transceiver';
export const GLIDE_SLOPE_TRANSCEIVER = 'glide-slope-transceiver';
export const DME_TRANSMITTER = 'dme-transmitter';
export const DME_RECEIVER = 'dme-receiver';
export const ATC_TRANSMITTER = 'atc-transmitter';
export const ATC_RECEIVER = 'atc-receiver';
export const WEATHER_C_BAND = 'weather-c-band';
export const WEATHER_X_BAND = 'weather-x-band';
export const WEATHER_ALTIMETER_TRANSCEIVER = 'weather-altimeter';
export const DOPPLER_NAV_TRANSCEIVER = 'doppler-nav-transceiver';
export const RADIO_ALTIMETER_TRANSCEIVER = 'radio-altimeter-transceiver';
export const GPS_RECEIVER = 'gps-receiver';
export const OTHERS = 'others';
export const CORRESPONDENCE_DETAILS = 'corrsepondence-details';
export const BILLING_DETAILS = 'billing-details';
export const NEW_AIRCRAFTLICENCE_APPLICATION = [
    {
        sectionID: AIRCRAFT_STATION_INFORMATION,
        sectionName: 'Aircraft Station Information',
        fieldList: [
            {
                id: 'callSign',
                label: 'Call Sign',
                type: 'text'
            },
            {
                id: 'aircraftCategory',
                label: 'Aircraft Category',
                type: 'text'
            },
            {
                id: 'registrationNo',
                label: 'Aircraft Registration No.',
                type: 'text'
            },
            {
                id: 'aircraftType',
                label: 'Aircraft Type',
                type: 'text'
            },
            {
                id: 'serialNo',
                label: 'Aircraft Serial No.',
                type: 'text'
            },
            {
                id: 'selectiveCallNo',
                label: 'Aircraft Selective Call No.',
                type: 'text'
            }
        ]
    },
    {
        sectionID: HF_TRANSCEIVER,
        sectionName: 'HF Transceiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 2.0 to 29.99 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 2.0 to 29.99 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VHF_TRANSCEIVER,
        sectionName: 'VHF Transceiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g 118.0 to 137.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g 118.0 to 137.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ADF_TRANSCEIVER,
        sectionName: 'ADF Transceiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 190 to 1799.5 kHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 190 to 1799.5 kHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: EMERGENCY_RADIO_BEACON,
        sectionName: 'Emergency Radio Beacon',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 121.5 and 243.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 121.5 and 243.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: MARKER_RECEIVER,
        sectionName: 'Marker Receiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 1025.0 to 1150.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 1025.0 to 1150.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: DME_RECEIVER,
        sectionName: 'D.M.E Receiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 962.0 to 1213.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 962.0 to 1213.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ATC_TRANSMITTER,
        sectionName: 'A.T.C Transmitter',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g 1090.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g 1090.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ATC_RECEIVER,
        sectionName: 'A.T.C Receiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 1030.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 1030.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: WEATHER_C_BAND,
        sectionName: 'Weather Radar Transceiver C Band',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. e.g. 4100.0 to 7000.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. e.g. 4100.0 to 7000.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: WEATHER_X_BAND,
        sectionName: 'Weather Radar Transceiver X Band',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 7000.0 to 15000.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 7000.0 to 15000.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: WEATHER_ALTIMETER_TRANSCEIVER,
        sectionName: 'Weather Altimeter Transceiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz)',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: DOPPLER_NAV_TRANSCEIVER,
        sectionName: 'Doppler NAV Transceiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 8750-8850 MHz ; 13250-13400 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 8750-8850 MHz ; 13250-13400 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: RADIO_ALTIMETER_TRANSCEIVER,
        sectionName: 'Radio Altimeter Transceiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 4200.0 to 4400.0 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 4200.0 to 4400.0 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: GPS_RECEIVER,
        sectionName: 'GPS Receiver',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'hfFrequencyFrom',
                label: 'Frequency From (MHz) e.g. 1575.42 MHz',
                type: 'text'
            },
            {
                id: 'hfFrequencyTo',
                label: 'Frequency To (MHz) e.g. 1575.42 MHz',
                type: 'text'
            }
        ]
    },
    {
        sectionID: OTHERS,
        sectionName: 'Others',
        fieldList: [
            {
                id: 'other',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'typeEquipment',
                        header: 'Type of equipment',
                        type: 'text'
                    },
                    {
                        id: 'manufacturer',
                        header: 'Manufacturer',
                        type: 'text'
                    },
                    {
                        id: 'model',
                        header: 'Model',
                        type: 'text'
                    },
                    {
                        id: 'frequencyFrom',
                        header: 'Frequency From (MHz)',
                        type: 'text'
                    },
                    {
                        id: 'frequencyTo',
                        header: 'Frequency To (MHz)',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
